<template>
    <div id="app">

        <element-loading :active="pageLoading"
                         :is-full-screen="true"
                         background-color="white">
            <img :src="require('./assets/svg/carnival-loader.svg')" width="450" height="180"/>
        </element-loading>

        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>

<script>
  import ElementLoading from 'vue-element-loading'
  import loadingAnimation from './assets/animations/LineProgressLoading.json'

  const defaultLayout = 'default'
  export default {
    data () {
      return {
        defaultOptions: { animationData: loadingAnimation }
      }
    },
    components: {
      ElementLoading
    },
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    }
  }
</script>
<style lang="scss">

</style>
